import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { AuthenticationService } from "./../../services/authentication.service";
import { RoutingUrl } from './../shared/enum/routing-url.enum';
import { ACLService } from '../../services/acl.service';
import { SocketIoService } from '../../services/socketio.service';

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
    constructor(private _router: Router, private _authService: AuthenticationService, private _aclService:ACLService,private _socketService:SocketIoService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let token = route.queryParams?.token;
        if(token){
            this._authService.authorizeWithToken(token);
        }
        const status = this._authService.isLoggedIn();
        if (!status) {
            sessionStorage.clear();
            this._router.navigate([RoutingUrl.LOGIN]);
        }else{
            this._aclService.initUserPermissionData();
            this._socketService.setupSocketConnection();
        }
       
        return status;
    }
}
